/* Converted to vanilla JS */
document.addEventListener('DOMContentLoaded', function () {
    // If we get a result back from the email signup then we should scroll to the email signup form
    try {
        var params = typeof GetUrlVars === 'function' ? GetUrlVars() : {};
        if (params && params['result'] === 'success') {
            var target = document.querySelector('.email-signup');
            if (target) {
                var top = target.getBoundingClientRect().top + window.pageYOffset - 50;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        }
    } catch (e) { }

    // add legals and submit btn for EMAIL signup
    var emailInputs = document.querySelectorAll('.email-signup-form input#email');
    emailInputs.forEach(function (inp) {
        inp.addEventListener('focus', function () {
            var disclaimer = document.querySelector('.email-signup-form .disclaimer');
            var btn = document.querySelector('.email-signup-form .btn');
            if (disclaimer) {
                disclaimer.classList.add('active');
                disclaimer.style.display = '';
            }
            if (btn) btn.classList.add('active');
        });
    });
});


